import React from 'react';

import { useTimer } from 'react-timer-hook';

import styles from './EnterConfirmationCodePage.module.scss';

const EXPIRY_SECONDS = 59;

const ResendCodeTimer = ({ onExpire }: { onExpire: () => void }) => {
  const expiryTimestamp = new Date();

  expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + EXPIRY_SECONDS);

  const { seconds } = useTimer({
    expiryTimestamp: expiryTimestamp,
    onExpire: onExpire,
  });

  return (
    <p className={styles.text}>
      You can request another code in <span className={styles.boldText}>{seconds}s</span>
    </p>
  );
};

export default ResendCodeTimer;
